export default __webpack_public_path__ + "static/media/ic_methodologist_active.fc485350.svg";